import { sortingOrderStatus } from '../../_constants/OrderStatusConst';

function FormatStatusId(id) {
  const status = sortingOrderStatus.find((item) => item.id === id);
  return status.name;
}

export default FormatStatusId;
